module.exports = __webpack_public_path__ + "static/media/auditoria.e27fe0f3.png";